export const SITE_URL = 'https://tsrcatering.co.in';

export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/images/01/custam.jpg`;

export const DEFAULT_SEO = {
  title: 'Best Caterers in Pune | Catering Services in Baner | TSR Catering',
  description: 'TSR Catering provides wedding, corporate, social event and buffet catering services across Pune, including Baner.',
  keywords: 'catering in pune, best caterers in pune, catering near baner, wedding caterers pune, buffet catering pune',
  ogImage: DEFAULT_OG_IMAGE,
};

export const ROUTE_SEO = {
  '/': DEFAULT_SEO,
  '/about': {
    title: 'About TSR Catering | Trusted Caterers in Pune & Baner',
    description: 'Learn about TSR Catering, a Pune catering team serving weddings, corporate events and celebrations from Baner.',
    keywords: 'tsr catering, caterers in pune, catering company in baner',
  },
  '/services': {
    title: 'Catering & Event Services in Pune | TSR Catering',
    description: 'Explore catering, event planning, decoration and canteen services from TSR Catering in Pune and Baner.',
    keywords: 'catering services in pune, event caterers pune, catering near baner',
  },
  '/catering': {
    title: 'Catering Services in Pune & Baner | TSR Catering',
    description: 'TSR Catering offers tailored catering services in Pune and Baner for family gatherings, weddings and events.',
    keywords: 'catering in pune, catering near baner, event catering pune',
  },
  '/buffet-catering': {
    title: 'Best Buffet & Wedding Caterers in Pune | TSR Catering',
    description: 'Choose TSR Catering for fresh buffet and wedding catering in Pune, including Baner and nearby locations.',
    keywords: 'best caterers in pune, buffet catering pune, wedding caterers pune',
  },
  '/wedding-events': {
    title: 'Wedding Caterers in Pune | TSR Catering',
    description: 'Memorable wedding catering in Pune with curated menus, service and event support from TSR Catering.',
    keywords: 'wedding caterers pune, wedding catering in pune, best caterers in pune',
  },
  '/corporate-events': {
    title: 'Corporate Catering Services in Pune | TSR Catering',
    description: 'Professional corporate event catering in Pune for meetings, launches, employee events and celebrations.',
    keywords: 'corporate catering pune, corporate event caterers pune',
  },
  '/social-events': {
    title: 'Social Event Caterers in Pune | TSR Catering',
    description: 'Catering for social events, parties and family celebrations in Pune and Baner by TSR Catering.',
    keywords: 'party caterers pune, social event catering pune, catering near baner',
  },
  '/canteen': {
    title: 'Corporate Canteen Catering in Pune | TSR Catering',
    description: 'Reliable corporate canteen and daily meal catering services for organisations across Pune.',
    keywords: 'canteen catering pune, corporate canteen services pune',
  },
  '/venues': {
    title: 'Event Venues & Catering in Pune | TSR Catering',
    description: 'Explore Pune event venue partners including LED Game Zone and catering support from TSR Catering.',
    keywords: 'event venues pune, birthday party venue pune, banquet catering pune',
  },
  '/contact': {
    title: 'Contact TSR Catering | Caterers in Baner, Pune',
    description: 'Contact TSR Catering for wedding, buffet, corporate and event catering enquiries in Pune and Baner.',
    keywords: 'contact caterers pune, catering near baner, tsr catering contact',
  },
  '/menu': {
    title: 'Catering Menus in Pune | TSR Catering',
    description: 'Browse menu ideas from TSR Catering for weddings, corporate events and celebrations in Pune.',
    keywords: 'catering menu pune, wedding catering menu pune',
  },
  '/catering-in-pune': {
    title: 'Catering in Pune | Best Caterers Near Baner | TSR Catering',
    description: 'Looking for catering in Pune or near Baner? TSR Catering provides menus and service for weddings, corporate events and celebrations.',
    keywords: 'catering in pune, best caterers in pune, catering near baner, caterers baner pune',
  },
  '/tsr-order': {
    title: 'Order Food Packages | TSR Catering',
    description: 'Browse and customize TSR Catering food packages for your event.',
    keywords: 'tsr catering food packages, order catering pune',
  },
};

const TSR_ADMIN_SEO = {
  title: 'TSR Admin',
  description: 'TSR Catering admin area.',
  robots: 'noindex,nofollow',
};

export const getSeoForPath = (pathname) => {
  const normalizedPath = pathname === '/' ? '/' : pathname.replace(/\/+$/, '');

  if (normalizedPath.startsWith('/tsr-admin')) {
    return { ...DEFAULT_SEO, ...TSR_ADMIN_SEO };
  }

  const configured = ROUTE_SEO[normalizedPath];

  if (configured) {
    return { ...DEFAULT_SEO, ...configured };
  }

  return {
    ...DEFAULT_SEO,
    title: `TSR Catering Services in Pune | ${DEFAULT_SEO.title}`,
  };
};
